/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { riskSessionQuarantinesListSessionQuarantines } from "../funcs/riskSessionQuarantinesListSessionQuarantines.js";
import { riskSessionQuarantinesReleaseSessionQuarantine } from "../funcs/riskSessionQuarantinesReleaseSessionQuarantine.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListSessionQuarantinesResult } from "../models/components/listsessionquarantinesresult.js";
import { SessionQuarantine } from "../models/components/sessionquarantine.js";
import {
  ListSessionQuarantinesRequest,
  ListSessionQuarantinesSecurity,
} from "../models/operations/listsessionquarantines.js";
import {
  ReleaseSessionQuarantineRequest,
  ReleaseSessionQuarantineSecurity,
} from "../models/operations/releasesessionquarantine.js";
import { unwrapAsync } from "../types/fp.js";

export class SessionQuarantines extends ClientSDK {
  /**
   * listSessionQuarantines risk
   *
   * @remarks
   * List active session quarantines for the current project.
   */
  async listSessionQuarantines(
    request?: ListSessionQuarantinesRequest | undefined,
    security?: ListSessionQuarantinesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListSessionQuarantinesResult> {
    return unwrapAsync(riskSessionQuarantinesListSessionQuarantines(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * releaseSessionQuarantine risk
   *
   * @remarks
   * Release an active session quarantine.
   */
  async releaseSessionQuarantine(
    request: ReleaseSessionQuarantineRequest,
    security?: ReleaseSessionQuarantineSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SessionQuarantine> {
    return unwrapAsync(riskSessionQuarantinesReleaseSessionQuarantine(
      this,
      request,
      security,
      options,
    ));
  }
}
